import React, { useEffect } from "react";
import visitImage from '../../images/shoe-icon.png';

interface Props {
    changeStepClick: (stepName: string) => void;
}

const Complete: React.FC<Props> = ({ changeStepClick }) => {
    useEffect(() => {
        const timeout = setTimeout(() => {
            changeStepClick("home");
        }, 5000);
        return () => clearTimeout(timeout);
    }, [changeStepClick]);

    return (
        <>
            <h1>Vent venligst</h1>
            <img className='center-image' src={visitImage} alt='wait' />
            <div className="bottom-text">- vi er på vej.</div>
        </>
    );
};

export default Complete;